import React from "react";

import Notfound from "../../assets/alerta.png";

import { Container } from "./styles";

const NotFound = () => (
    <Container>
        <div className="primary">
            <img className="alerta alertaimg" alt="alerta" src={Notfound} />
            <strong>
                <p className="corpotextomanutencao">Página não encontrada</p>
            </strong>
        </div>
    </Container>
);

export default NotFound;
